// Classes.
import {BaseLocator} from './../locators/base.locator';


export class CountryNamesListLocator extends BaseLocator {

  constructor() {
    super('countryNamesList');
  }
}

